import i from "react-dom";
import f from "react";
import { P as u } from "./react-dropzone.DBUV1vcP.js";
var c = !!(typeof window < "u" && window.document && window.document.createElement), p = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function h(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function y(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function m(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var l = function(t) {
  m(e, t);
  function e() {
    return h(this, e), y(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return p(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function() {
      return c ? (!this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode)), i.createPortal(this.props.children, this.props.node || this.defaultNode)) : null;
    }
  }]), e;
}(f.Component);
l.propTypes = {
  children: u.node.isRequired,
  node: u.any
};
var b = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function v(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function s(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var d = function(t) {
  s(e, t);
  function e() {
    return v(this, e), _(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return b(e, [{
    key: "componentDidMount",
    value: function() {
      this.renderPortal();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      this.renderPortal();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      i.unmountComponentAtNode(this.defaultNode || this.props.node), this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null, this.portal = null;
    }
  }, {
    key: "renderPortal",
    value: function(r) {
      !this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode));
      var o = this.props.children;
      typeof this.props.children.type == "function" && (o = f.cloneElement(this.props.children)), this.portal = i.unstable_renderSubtreeIntoContainer(this, o, this.props.node || this.defaultNode);
    }
  }, {
    key: "render",
    value: function() {
      return null;
    }
  }]), e;
}(f.Component);
d.propTypes = {
  children: u.node.isRequired,
  node: u.any
};
var a = void 0;
i.createPortal ? a = l : a = d;
export {
  a as D,
  a as P
};
//# sourceMappingURL=react-portal.YvhPAbjo.js.map
